enum LocalStorageItem {
  licenceAgree = "licenceAgree",
  token = "token",
  email = "email",
  domain = "domain",
}

export default LocalStorageItem;
